export const selectToken = (state: any) => state.auth.token;
export const selectUser = (state: any) => state.auth.user;
export const selectManageUserTabIndex = (state: any) => state.admin.manageUserTabIndex;
export const selectClientResourceTabIndex = (state: any) => state.admin.clientResourceTabIndex;
export const selectResourceIndex = (state: any) => state.admin.resourceIndex;
export const selectWinRateResourceTabIndex = (state: any) => state.admin.winRateResourceTabIndex;
export const selectRecentCallsResourceTabIndex = (state: any) => state.admin.recentCallsResourceTabIndex;
